import React from 'react';
import '../gral-stylesheets/border-curved.scss';



class BorderCurved extends React.Component {
  render() {
    return (  
      <div 
        className='background-curve-container'
        style={this.props.background}
        >
        <svg
          className={this.props.transform ? 'curve transform' : 'curve'}
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          preserveAspectRatio='none'
          viewBox='0 0 1680 30'
        >
          <path
            d='M0 40h1680V30S1340 0 840 0 0 30 0 30z'
            fill={this.props.fill}
          />
        </svg>
      </div>
    )
  }
}

export default BorderCurved;